import { useAuth } from '../contexts/AuthContext';

const Dashboard = () => {
  const { user, logout } = useAuth();

  if (!user) {
    return (
      <div className="loading-container">
        <p>Loading user data...</p>
      </div>
    );
  }

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Welcome to Cartoon Us!</h1>
        <div className="user-info">
          {user.picture && (
            <img 
              src={user.picture} 
              alt={user.name || user.email} 
              className="user-avatar" 
            />
          )}
          <div className="user-details">
            <h2>{user.name || 'User'}</h2>
            <p>{user.email}</p>
          </div>
        </div>
        <button className="logout-button" onClick={logout}>
          Logout
        </button>
      </div>

      <div className="dashboard-content">
        <div className="upload-section">
          <h2>Transform Your Photo</h2>
          <p>Upload a photo to transform it into Studio Ghibli-style artwork</p>
          
          <button className="upload-button">
            Upload Photo
          </button>
        </div>

        <div className="subscription-section">
          <h2>Your Subscription</h2>
          <p>Free Plan: 0/1 transformations available</p>
          <button className="upgrade-button">
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 